<template>
  <div class="home b-s" ref="menu">
    <div class="position-relative b-s">
      <img src="../assets/witstar/1.png" alt="">
      <Header></Header>
      <div class="title-content">
        <div class="big-title animate__animated animate__fadeInDown">{{$t('witstar.title1')}}</div>
        <div class="small-title animate__animated animate__fadeInUp">{{$t('witstar.desc1')}}</div>
      </div>
      <div class="witstar animate__animated animate__fadeInLeft">
        WITSTAR
      </div>
      <div class="who animate__animated animate__fadeInRight">
        WHO ARE WE
      </div>
    </div>
    <div class="introduce-wrapper">
      <div class="title-wapper">
        <div class="right-wrapper animate__animated animate__fadeInDown">
          <div class="title">{{$t('home.title2')}}</div>
        </div>
        <div class="left-wrapper animate__animated animate__fadeInDown">
          <p>{{$t('home.desc2_1')}}</p>
          <p>{{$t('home.desc2_2')}}</p>
        </div>
      </div>
    </div>
    <div class="join-wrapper">
      <div class="join-left">
        <img class="join-left-img animate__animated" src="../assets/witstar/2.png" />
      </div>
      <div class="join-right">
        <div class="title-1 animate__animated" style="color:#d9d9d9;"><span>{{$t('witstar.title2')}}</span></div>
        <div class="title—2">
          <div class="slideRight1 animate__animated"><span style="color: #424242">{{$t('witstar.title3')}}</span><span style="color: #e2273e">{{$t('witstar.title4')}}</span></div>
        </div>
        <div class="title—3" style="color: #d9d9d9">
          <div class="slideLeft1 animate__animated"><span>{{$t('witstar.title5')}}</span></div></div>
        <div class="title—4">
          <div class="slideRight2 animate__animated"><span style="color: #e2273e">{{$t('witstar.title6')}}</span><span style="color: #424242">{{$t('witstar.title7')}}</span></div>
        </div>
        <div class="image animate__animated"> <img src="../assets/witstar/3.png" /></div>
      </div>
    </div>

    <div class="advantage-wrapper position-relative">
      <img class="bg-img animate__animated" src="../assets/witstar/4.png" alt="">
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
  export default {
    components: {Header, Footer},
    data() {
      return {
        zoom: 50,
      }
    },
    methods: {
    },
    mounted() {
      const io = new IntersectionObserver(entries => {
        entries.forEach(item => {
          if (item.isIntersecting) {
            if (item.target.classList[0] == 'join-left-img') {
              item.target.classList.add('animate__fadeInLeft')
            }
            if (item.target.classList[0] == 'bg-img') {
              item.target.classList.add('animate__zoomIn')
            }
            if (item.target.classList[0] == 'title-1') {
              item.target.classList.add('animate__slideInLeft')
            }
            if (item.target.classList[0] == 'slideRight1') {
              item.target.classList.add('animate__slideInRight')
            }
            if (item.target.classList[0] == 'slideLeft1') {
              item.target.classList.add('animate__slideInLeft')
            }
            if (item.target.classList[0] == 'slideRight2') {
              item.target.classList.add('animate__slideInRight')
            }
            if (item.target.classList[0] == 'image') {
              item.target.classList.add('animate__fadeInUp')
            }
          }
        })
      }, {})

      const nodeLists = [...document.querySelectorAll('.animate__animated')]
      nodeLists.forEach(box => {
        io.observe(box)
      })
    }
  }
</script>
<style lang="scss" scoped>
.title-content {
  width: 100%;
  position: absolute;
  top: 175px;
  left: 0;
  right: 0;
  z-index: 11;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .big-title {
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }
  .small-title {
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 40px;
    margin-top: 48px;
  }
}

.zh {
  .big-title {
    font-size: 67px;
    line-height: 67px;
  }
}

.en {
  .big-title {
    font-size: 60px;
    line-height: 62px;
    padding: 0 20%;
    text-align: center;
    //width: 60%;
  }
}

.witstar {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  bottom: 148px;
  left: 0;
  right: 0;
  z-index: 11;
  text-align: start;
  padding-left: 468px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 28px;
  color: #FFFFFF;
  line-height: 28px;
}

.who {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 139px;
  left: 0;
  right: 0;
  z-index: 11;
  text-align: end;
  padding-right: 120px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 28px;
  color: #FFFFFF;
  line-height: 28px;
}

.introduce-wrapper {
  display: flex;
  width: 60%;
  margin: 0 auto;
  font-family: Microsoft YaHei;
  align-items: center;
  box-sizing: border-box;
  padding: 100px 0;
  .title-wapper {
    display: flex;
  }
  .right-wrapper {
    font-weight: bold;
    font-size: 48px;
    color: #424242;
    line-height: 40px;
    margin-right: 5%;
    margin-top: 10px;
  }
  .left-wrapper {
    flex: 1;
  }
  p {
    text-align: left;
    text-indent:40px;
    font-weight: 400;
    font-size: 20px;
    color: #73788C;
    line-height: 40px;
    word-wrap:break-word;
    margin: 0;
  }
}

.join-wrapper {
  display: flex;
  width: 100%;
  height: 540px;
  box-sizing: border-box;
  .join-left {
    width: 52%;
  }
  .join-right {
    width: 48%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    box-sizing: border-box;
    padding: 20px 0px;
    overflow: hidden;
    div {
      width: 100%;
    }
    .title-1 {
      line-height: 42px;
    }
    .title—4 {
      span{
        line-height: 42px;
      }
    }
    .image {
      width: 638px;
      height: 123px;
    }
  }
}

.zh {
  .join-right {
    font-size: 42px;
    .title—2 {
      div {
        margin-left: 132px;
      }
      span{
        line-height: 42px;
      }
    }
    .title—3 {
      line-height: 42px;
      div {
        margin-left: -132px;
      }
    }
  }
}

.en {
  .join-right {
    font-size: 32px;
    .title—2 {
      div {
      }
    }
    .title—3 {
      div {
      }
    }
  }
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.advantage-wrapper {
  height: 976px;
}


</style>
